import { sessionStorage } from '../../../../helpers/storage';
import { SESSION_STORAGE_FORM_KEY } from '../../../../constants';

export const isNewData = (prevData: FE.FormData, currentData: FE.FormData) => {
    return JSON.stringify(prevData) !== JSON.stringify(currentData);
};

const sessionFormData = {
    modifiedButNotSaved: {} as FE.FormData,
};

export const clearSessionStorageFormData = () => {
    sessionFormData.modifiedButNotSaved = {};
    sessionStorage.removeItem(SESSION_STORAGE_FORM_KEY);
};

export const updateModifiedData = (data: FE.FormData) => {
    Object.assign(sessionFormData.modifiedButNotSaved, data);
    return sessionFormData.modifiedButNotSaved;
};
